import styled from "styled-components";
import FramePuzzlePrizes from "../../../../assets/images/Event-2026/FramePuzzlePrizes.png";
// import FramePuzzlePrizes22 from "../../../../assets/images/Event-2026/FramePuzzlePrizes22.png.png";
import Icon1 from "../../../../assets/images/Event-2026/icon top.svg";
import Icon2 from "../../../../assets/images/Event-2026/icon2.svg";
import Product from "../../../../assets/images/Event-2026/product.png";
import BgProd from "../../../../assets/images/Event-2026/bg-prod.png";
import React, { useEffect } from "react";
import { Button } from "antd";
import { useNavigate } from '@hooks/useNavigate';
import PATH from '@config/PATH';
import { ID_TAB_MINI_GAME } from 'helper/const';
import { useQuery } from 'react-query';
import { getMiniGamePrizeCollectionQuery } from 'dataLayer/miniGame';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

const ItemProduct = ({ item }) => {
  const navigate = useNavigate();

  return (
    <div
      className="item-product"
      onClick={() => navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.pieceCollection}/${item.id}`)}
    >
      <img src={item.image} alt="product" />
      <p>{item.name}</p>
    </div>
  );
};
export default function PuzzlePrizes() {
  const navigate = useNavigate();
  const { t } = useTranslation()

  const { data } = useQuery(
    getMiniGamePrizeCollectionQuery()
  );

  const handleChangeTakePrize = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.takePrize}`);
  }

  const handleChangeCollectPiece = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.pieceCollection}`);
  }

  const handleChangePrizeCollection = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.prizeCollection}`);
  }

  return (
    <Container>
      <div className="frame">
        <h4 className="title">{t('puzzle_prizes')}</h4>
        <span className="btn-sell" onClick={handleChangePrizeCollection}>
          <span>{t('see_all')}</span>
        </span>
        <div className="list">
          <div className="list-product">
            {data?.length > 0 && data?.map((item, index) => (
              <ItemProduct key={index} item={item} />
            ))}
          </div>
        </div>
        <div className="btn">
          <Button className="take-prize" onClick={handleChangeTakePrize}>
            <img src={Icon1} alt="icon" />
            <span>{t('take_prize')}</span>
          </Button>
          <Button className="piece-collection" onClick={handleChangeCollectPiece}>
            <img src={Icon2} alt="icon" />
            <span>{t('piece_collection')}</span>
          </Button>
        </div>
      </div>
    </Container>
  );
}
const Container = styled.div`
  .frame {
    background-image: url(${FramePuzzlePrizes});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 506px;
    position: relative;
    overflow: hidden;
    max-width: 1200px;
    margin: auto;

    @media (max-width: 768px) {
      width: 100%;
      height: 360px;
    }
  }

	.btn-sell{
		border: none;
		outline: none;
		width: 124px;
    height: 40px;
    position: absolute;
    top: 2px;
    right: 4%;
		text-align: right;
		z-index: 2;

		@media (max-width: 768px) {
				background-size: 100% 100%;
				width: 90px;
				height: 40px;
				top: 12px;
				right: 25px;
		}

		@media (max-width: 480px) {
			background-size: 100% 100%;
				width: 70px;
				height: 40px;
				top: 12px;
				right: 9px;
		}

	
		 @media (min-width: 768px) and (max-width: 1024px) {
			 right: 25px;
				top: 12px;
			}

			@media (min-width: 834px) and (max-width: 1194px) {
				right: 30px;
				top: 12px;
			}

			@media (min-width: 1024px) and (max-width: 1366px) {
				right: 25px;
				top: 12px;
			}


		span{
			display: inline-block;
			padding-top: 25px;
			padding-right: 20px;
			text-align: right;
			font-weight: 700;
			font-size: 20px;
			text-decoration: underline;
			color: #fff;
			cursor: pointer;

			@media (max-width: 480px) {
        font-size: 12px;
        padding-right: 10px;
      }

      @media (max-width: 768px) {
        padding-top: 10px;
				font-size: 12px;
        padding-right: 13px;
      }

			@media (min-width: 768px) and (max-width: 1024px) {
			padding-top: 20px;
        padding-right: 10px;
			font-size: 16px;

			}

			@media (min-width: 834px) and (max-width: 1194px) {
				padding-top: 18px;
			font-size: 16px;
        padding-right: 10px;
			}

			@media (min-width: 1024px) and (max-width: 1366px) {
				padding-top: 17px;
			font-size: 18px;
        padding-right: 30px;
			}
		}
	}

.title{
		color: rgba(253, 221, 16, 1);
		font-size: 20px;
		font-weight: 800;
		text-transform: uppercase;
		position: absolute;
		top: 43px;
    left: 4.5%;

		@media (max-width: 768px) {
			top: 7%;
			left: 5%;
			font-size: 13px;
			max-width: 250px;
		}
		@media (min-width: 768px) and (max-width: 1024px) {
				font-size: 14px;
			}

			@media (min-width: 834px) and (max-width: 1194px) {
						font-size: 16px;
			}

			@media (min-width: 1024px) and (max-width: 1366px) {
						font-size: 18px;

			}
	}

  .list {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    box-sizing: border-box;
    padding: 0 42px;
    box-sizing: border-box;
    @media (max-width: 768px) {
      padding: 0 20px;
    }
  }

  .list-product {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    scroll-behavior: smooth;
    width: 100%;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    justify-content: center;

    @media (max-width: 768px) {
      justify-content: left;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    @media (min-width: 768px) and (max-width: 1024px) {
      justify-content: left;
    }

    @media (min-width: 834px) and (max-width: 1194px) {
      justify-content: left;
    }

    @media (min-width: 1024px) and (max-width: 1366px) {
      justify-content: left;
    }
  }

  .item-product {
    min-width: 110px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    img {
      width: 180px;
      height: 180px;
      object-fit: contain;
      background: url(${BgProd});
      background-size: cover;
      background-position: center;
      border-radius: 8px;
      padding: 35px;
      @media (max-width: 768px) {
        width: 120px;
        height: 120px;
      }
    }

    p {
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      max-width: 130px;
      color: #fff;
      /* margin-top: 6px; */
      padding: 4px 8px;
      border-radius: 6px;

      background: linear-gradient(
        90deg,
        rgba(0, 50, 248, 0) 0%,
        rgba(0, 51, 255, 1) 50%,
        rgba(0, 50, 248, 0) 100%
      );

      @media (max-width: 768px) {
        font-size: 13px;
        line-height: 20px;
      }
    }
  }

  .btn {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 25px 40px;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 0 20px;
    }

    button {
      border: none;
      outline: none;
      border-radius: 8px;
      padding: 7px 14px;
      height: 43px;

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
	  width: 100%;
      max-width: 100%;

      img {
        width: 18px;
        height: 18px;
      }

      span {
        color: #fff;
        font-weight: 600;
        font-size: 16px;
         word-break: break-word;
        white-space: normal;
        line-height: 18px;
      }
    }

    .take-prize {
      background: linear-gradient(180deg, rgba(217, 96, 20, 1) 0%, rgba(254, 145, 4, 1) 100%);
    }

    .piece-collection {
      background: linear-gradient(180deg, rgba(30, 163, 23, 1) 0%, rgba(25, 184, 16, 1) 100%);
    }
  }
`;
